module.exports = __webpack_public_path__ + "static/img/12.e13a8ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/12.png
// module id = bnwg
// module chunks = 0